import React from "react";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { CircularProgress } from "@mui/material";

import FavoriteStarLabel from "../../FavoriteStarLabel/FavoriteStarLabel";
import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ModalRow.module.css";

interface Props {
  name: string;
  onClick: () => void;
  isFavorite: boolean;
  setFavorite: () => void;
  isLoading: boolean;
}

const ModalRow: React.FC<Props> = ({
  name,
  onClick,
  isFavorite,
  setFavorite,
  isLoading,
}: Props) => {
  const handleSetFavorite = (e: React.MouseEvent) => {
    e.stopPropagation();
    setFavorite();
  };
  return (
    <div className={styles.container} onClick={onClick}>
      <Text variant="body" color={"text"}>
        {name}
      </Text>

      <div className={styles.flexRow}>
        {isLoading ? (
          <div className={styles.loader}>
            <CircularProgress color={"inherit"} size={20} />
          </div>
        ) : isFavorite ? (
          <FavoriteStarLabel />
        ) : (
          <Tooltip tooltipText="Favorite" placement="top">
            <StarBorderIcon
              className={styles.starIcon}
              onClick={handleSetFavorite}
            />
          </Tooltip>
        )}

        <KeyboardArrowRightIcon className={styles.icon} />
      </div>
    </div>
  );
};

export default ModalRow;
